export const login_popup_events = {
  Google_login_click: {
    category: "User loging in with google",
    action: "User loging in with google",
    label: "log-in-with-google-click",
  },
  Apple_login_click: {
    category: "User loging in with apple",
    action: "User clicks on login with apple button",
    label: "log-in-with-apple-click",
  },
  Facebook_login_click: {
    category: "User loging in with facebook",
    action: "User clicks on login with facebook button",
    label: "log-in-with-facebook-click",
  },
  Forgot_password_click: {
    category: "User wants navigates to forgot password popup",
    action: "User clicks on forgot password button",
    label: "log-in-reset-password-click",
  },
  Forgot_password_send_link_click: {
    category: "User asking for reset password link",
    action: "User clicks on send reset password link button",
    label: "log-in-reset-password-send-click",
  },
  Create_new_account_click: {
    category: "User wants to signup or create a new account",
    action: "User clicks on 'create one now' button",
    label: "Create-new-account-click",
  },
  Login_with_email_submit: {
    category: "User loging in with email and password",
    action: "User clicks on 'Log In' button",
    label: "log-in-with-email-submit-click",
  },
  Login_reset_password_email_input_click: {
    category: "User wants to reset password",
    action: "User clicks on 'Reset Password Input",
    label: "log-in-reset-password-email-input-click",
  },
  signup_complete: {
    category: "New User Signup completed",
    action: "User clicks on Log In button",
    label: "signup-complete",
  },

  signup_complete_google: {
    category: "Signup",
    action: "User successfully signs up with Google",
    label: "sign-up-complete-google",
  },
  signup_complete_apple: {
    category: "Signup",
    action: "User successfully signs up with Apple",
    label: "sign-up-complete-apple",
  },
  signup_complete_facebook: {
    category: "Signup",
    action: "User successfully signs up with Facebook",
    label: "sign-up-complete-facebook",
  },
  signup_complete_email: {
    category: "Signup",
    action: "User successfully signs up with Email",
    label: "sign-up-complete-email",
  },

  log_in_success_google: {
    category: "Login",
    action: "User successfully logs in with Google",
    label: "log-in-success-google",
  },
  log_in_success_apple: {
    category: "Login",
    action: "User successfully logs in with Apple",
    label: "log-in-success-apple",
  },
  log_in_success_facebook: {
    category: "Login",
    action: "User successfully logs in with Facebook",
    label: "log-in-success-facebook",
  },
  log_in_success_email: {
    category: "Login",
    action: "User successfully logs in with Email",
    label: "log-in-success-email",
  },
  login: {
    category: "Login",
    action: "User successfully logs in",
    label: "login",
  },
};
